import React from "react"
import Ticker from "react-ticker"
import { StaticImage } from "gatsby-plugin-image"

const SideBar = () => (
  <aside className="sticky top-0 z-40 hidden w-64 h-screen bg-black sidebar xl:flex pt-14">
    <div className="flex flex-col justify-between">
      <Ticker>
        {({ index }) => (
          <div
            key={index}
            className="m-4 text-lg text--uppercase whitespace-nowrap"
          >
            ANACHROME
          </div>
        )}
      </Ticker>
      <div>
        <video
          muted
          autoPlay
          loop
          src="https://cdn.shopify.com/s/files/1/0561/1464/3101/files/Promo_45_Sec_Supernaut_Intro.mov?v=1631062032"
        />
      </div>
    </div>
  </aside>
)

export default SideBar
